import React from "react";
import { palettes } from "@trainline/depot-web/css";
const IconCallingPointIntermediate = ({
  size = "10px",
  offsetY = "4px",
  pathWidth = "3px",
  pathColor = palettes.dp_brand_neutral_dim,
  markerColor = palettes.dp_brand_white
}) => /* @__PURE__ */ React.createElement("span", {
  style: {
    height: "100%",
    position: "relative",
    display: "flex",
    justifyContent: "center"
  }
}, /* @__PURE__ */ React.createElement("span", {
  style: {
    zIndex: 1,
    width: size,
    height: size,
    borderRadius: "100%",
    backgroundColor: markerColor,
    border: `2px solid ${pathColor}`,
    transform: `translateY(${offsetY})`
  }
}), /* @__PURE__ */ React.createElement("span", {
  style: {
    position: "absolute",
    width: pathWidth,
    height: "100%",
    backgroundColor: pathColor
  }
}));
var IconCallingPointIntermediate_default = IconCallingPointIntermediate;
export {
  IconCallingPointIntermediate_default as default
};
